var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"trigger":"hover","placement":"top-start","content":_vm.mapFun(_vm.state,_vm.stateList)}},[_c('StateDot',{attrs:{"state":_vm.state}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }